import React from 'react';
import Page from '../../layout/Page';
import Settings from './Settings';
import RoleProtected, { userRoles } from '../../RoleProtected';

const SettingsPage = () => (
    <RoleProtected roles={userRoles.accountConfiguration}>
        <Page title='Settings' icon='mobile'>
            <Settings />
        </Page>
    </RoleProtected>
);

export default SettingsPage;
